import PrivateRoute from 'routes/protectedRoute';
import SwitchRoutes from 'routes/SwitchRoutes';

export { SwitchRoutes };

export default PrivateRoute;
